import React from 'react'

// 피그마 DS 아이콘(20 격자 · 선 1.75)을 그대로 옮겼다
type IconProps = React.SVGProps<SVGSVGElement>

const ShellIcon: React.FC<IconProps & { paths: string[]; size?: number }> = ({ paths, size = 20, ...props }) => (
    <svg
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        {...props}
    >
        {paths.map((path) => (
            <path key={path} d={path} />
        ))}
    </svg>
)

export const SidebarIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M5 3.875H15C16.1736 3.875 17.125 4.82639 17.125 6V14C17.125 15.1736 16.1736 16.125 15 16.125H5C3.82639 16.125 2.875 15.1736 2.875 14V6C2.875 4.82639 3.82639 3.875 5 3.875Z',
            'M7.75 3.875V16.125'
        ]}
        {...props}
    />
)

export const UserIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M3.75 16.6666C3.75 15.009 4.40848 13.4193 5.58058 12.2472C6.75268 11.0751 8.3424 10.4166 10 10.4166C11.6576 10.4166 13.2473 11.0751 14.4194 12.2472C15.5915 13.4193 16.25 15.009 16.25 16.6666M13.3333 6.66659C13.3333 8.50753 11.8409 9.99992 10 9.99992C8.15905 9.99992 6.66667 8.50753 6.66667 6.66659C6.66667 4.82564 8.15905 3.33325 10 3.33325C11.8409 3.33325 13.3333 4.82564 13.3333 6.66659Z'
        ]}
        {...props}
    />
)

export const GlobeIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5M17.5 10C17.5 5.85786 14.1421 2.5 10 2.5M17.5 10H12.7302M10 17.5C5.85786 17.5 2.5 14.1421 2.5 10M10 17.5C11.7635 15.3987 12.7302 12.7432 12.7302 10M10 17.5C8.2365 15.3987 7.26984 12.7432 7.26984 10M2.5 10C2.5 5.85786 5.85786 2.5 10 2.5M2.5 10H7.26984M10 2.5C11.7635 4.60127 12.7302 7.25677 12.7302 10M10 2.5C8.2365 4.60127 7.26984 7.25677 7.26984 10M7.26984 10H12.7302'
        ]}
        {...props}
    />
)

export const MapPinIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M9.99984 17.4999C9.99984 17.4999 4.1665 12.3333 4.1665 7.91659C4.1665 6.36949 4.78109 4.88576 5.87505 3.7918C6.96901 2.69783 8.45274 2.08325 9.99984 2.08325C11.5469 2.08325 13.0307 2.69783 14.1246 3.7918C15.2186 4.88576 15.8332 6.36949 15.8332 7.91659C15.8332 12.3333 9.99984 17.4999 9.99984 17.4999ZM12.0832 7.91659C12.0832 9.06718 11.1504 9.99992 9.99984 9.99992C8.84924 9.99992 7.9165 9.06718 7.9165 7.91659C7.9165 6.76599 8.84924 5.83325 9.99984 5.83325C11.1504 5.83325 12.0832 6.76599 12.0832 7.91659Z'
        ]}
        {...props}
    />
)

export const MapIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M12.5 5.83398L7.5 3.33398L2.5 5.83398V16.6673L7.5 14.1673M7.5 3.33398V14.1673M7.5 14.1673L12.5 16.6673L17.5 14.1673V3.33398L12.5 5.83398M12.5 5.83398V16.6673'
        ]}
        {...props}
    />
)

export const LogoutIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        paths={[
            'M11.6667 3.33325H15C15.442 3.33325 15.866 3.50885 16.1785 3.82141C16.4911 4.13397 16.6667 4.55789 16.6667 4.99992V14.9999C16.6667 15.4419 16.4911 15.8659 16.1785 16.1784C15.866 16.491 15.442 16.6666 15 16.6666H11.6667M8.33333 13.3333L5 9.99992L8.33333 6.66659M5 9.99992H13.3333'
        ]}
        {...props}
    />
)

export const CheckIcon: React.FC<IconProps> = (props) => (
    <ShellIcon paths={['M4.1665 10.4166L7.9165 14.1666L15.8332 5.83325']} {...props} />
)

export const ChevronDownIcon: React.FC<IconProps> = (props) => (
    <ShellIcon paths={['M5 7.5L10 12.5L15 7.5']} {...props} />
)

export const ChevronRightIcon: React.FC<IconProps> = (props) => (
    <ShellIcon paths={['M7.5 5L12.5 10L7.5 15']} {...props} />
)

export const ChevronLeftIcon: React.FC<IconProps> = (props) => (
    <ShellIcon paths={['M12.5 5L7.5 10L12.5 15']} {...props} />
)

const SPEAKER_PATH = 'M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5'

export const VolumeIcon: React.FC<IconProps> = (props) => (
    <ShellIcon size={24} strokeWidth={2.1} paths={[SPEAKER_PATH, 'M15 8a5 5 0 0 1 0 8', 'M17.7 5a9 9 0 0 1 0 14']} {...props} />
)

export const VolumeOffIcon: React.FC<IconProps> = (props) => (
    <ShellIcon size={24} strokeWidth={2.1} paths={[SPEAKER_PATH, 'M16 10l4 4m0 -4l-4 4']} {...props} />
)

export const HelpCircleIcon: React.FC<IconProps> = (props) => (
    <ShellIcon
        size={24}
        strokeWidth={2}
        paths={['M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', 'M12 16v.01', 'M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483']}
        {...props}
    />
)
